import { render } from "./CardRowData.vue?vue&type=template&id=a4d41ed2&ts=true"
import script from "./CardRowData.vue?vue&type=script&lang=ts"
export * from "./CardRowData.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__